"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectTo = void 0;
var _router = _interopRequireDefault(require("next/router"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *
 * HOF implementation which re-routes the mounted comonent to the specified
 * path.
 */
var redirectTo = path => {
  var Redirect = () => {
    return null;
  };
  Redirect.getInitialProps = _ref => {
    var {
      res
    } = _ref;
    if (res) {
      res.writeHead(302, {
        Location: path
      });
      res.end();
    } else {
      _router.default.replace(path);
    }
    return {};
  };
  return Redirect;
};
exports.redirectTo = redirectTo;